import PropTypes from 'prop-types';
import React from 'react';
import VideoPlayer from 'components/contentBlocks/VideoPlayer';
import colors from 'config/theme/colors';
import decodeHTMLEntities from '@nwg/core-web/utils/decodeHTMLEntities';
import { mediaQueries } from 'config/theme/breakpoints';
import transformFlexibleBackground from 'libs/wordpress/utils/transformFlexibleBackground';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

// Pure CMS data transformation before we send it to the "real" block!
const VideoPlayerBlock = ({ content, moduleTextColor = '' }) => {
    const {
        background_media_flexible: backgroundFlexible,
        heading,
        play_button: playButton,
        tag,
        text_color: blockTextColor,
        video: videoData,
    } = content;

    // Transform background and video data
    const isAboveSm = useAboveBreakpoint('sm');
    const transformedBackground = transformFlexibleBackground(backgroundFlexible);
    const transformedVideo = transformFlexibleBackground(videoData, 'video');
    const mobileBackground = transformedBackground.mobile;
    const desktopBackground = transformedBackground.desktop;
    const mobileVideo = transformedVideo.mobile;
    const desktopVideo = transformedVideo.desktop;

    // Transform color data
    const ligthThemeModule = moduleTextColor === 'white';
    const ligthThemeBlock = blockTextColor === 'white';
    const textColor = ligthThemeModule ? colors.white : colors.black;
    const playButtonColor = ligthThemeBlock ? colors.white : colors.black;
    const invertedPlayButtonColor = ligthThemeBlock ? colors.black : colors.white;

    return (
        <VideoPlayer
            background={isAboveSm ? desktopBackground : mobileBackground}
            backgroundType={isAboveSm ? desktopBackground.type : mobileBackground.type}
            buttonText={playButton}
            heading={heading ? decodeHTMLEntities(heading.text) : null}
            headingTag={heading ? heading.type : null}
            invertedPlayButtonColor={invertedPlayButtonColor}
            mediaQuery={mediaQueries.fullWidth}
            playButtonColor={playButtonColor}
            tag={decodeHTMLEntities(tag)}
            textColor={textColor}
            video={isAboveSm ? desktopVideo : mobileVideo}
        />
    );
};

VideoPlayerBlock.propTypes = {
    content: PropTypes.shape({
        'background_media_flexible': PropTypes.exact({
            mobile: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
            desktop: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
        }),
        heading: PropTypes.object,
        tag: PropTypes.string,
        'play_button': PropTypes.string,
        'text_color': PropTypes.string,
        video: PropTypes.object,
    }).isRequired,
    moduleTextColor: PropTypes.string,
};

export default VideoPlayerBlock;
